<template>
  <div>
    <!-- $popper Tooltip -->
    <section class="is-inline-block ml-1 mr-1">
      <div
        ref="topArrow"
        class="score is-clickable"
        @mouseenter="$popper.togglePopper($refs.topArrow, $refs.topMenu)"
        @mouseleave="$popper.togglePopper($refs.topArrow, $refs.topMenu)"
      >
        <b-icon
          icon="information"
          size="is-small"
          type="is-info"
          class="is-clickable"
        ></b-icon>
      </div>

      <div
        ref="topMenu"
        class="filterBox popper-popup"
        style="background: #222222;"
      >
        <div class="p-1 has-text-white" style="font-size:13px;">
          <div class="columns mt-0 mb-0 has-text-grey-light">
            <div class="column p-0 mb-0 has-text-left">
              Original Fare (approx)
            </div>
            <div class="column p-0 mb-0 has-text-right is-narrow">
              {{ originalFare | formatCurrency(0, originalCurrency ) }} <!-- TODO Get/confirm currency code from PNR/pricing-->
            </div>
          </div>

          <div
            class="columns mt-0 mb-2"
            style="border-bottom: 3px solid white;"
          >
            <div class="column p-0 has-text-left">New Fare (est)</div>
            <div class="column p-0 has-text-right is-narrow">
              {{ solution.pricing.total | formatCurrency(0, solution.pricing.currencyCode) }}
            </div>
          </div>

          <template v-if="true">
            <div class="columns mt-0 mb-0 has-text-grey-light">
              <div class="column p-0 has-text-left">Fare Difference</div>
              <div class="column p-0 has-text-right is-narrow">
                {{ fareDifference | formatCurrency(0, solution.pricing.currencyCode) }}
              </div>
            </div>

            <div class="columns mt-0 mb-0 has-text-grey-light">
              <div class="column  p-0 has-text-left">Tax Difference</div>
              <div class="column  p-0 has-text-right is-narrow">
                {{ taxDifference | formatCurrency(0, solution.pricing.currencyCode) }}
              </div>
            </div>
          </template>

          <div class="columns mt-0 mb-0 has-text-grey-light">
            <div class="column p-0 has-text-left">Exchange Fee</div>
            <div class="column p-0 has-text-right is-narrow">
              {{ solution.pricing.exchangePenalty | formatCurrency(0, solution.pricing.currencyCode) }}
            </div>
          </div>

          <div class="columns mt-0 mb-2">
            <div class="column  p-0 has-text-left">Total Difference</div>
            <div class="column  p-0 has-text-right is-narrow">
              {{ solution.pricing.totalDifference | formatCurrency(0, solution.pricing.currencyCode) }}
            </div>
          </div>


          <div class="columns mt-0 mb-0 has-text-weight-bold">
            <div class="column p-0 has-text-left">Total Due</div>
            <div class="column p-0 has-text-right is-narrow">
              {{ solution.pricing.totalDue | formatCurrency(0, solution.pricing.currencyCode) }}
            </div>
          </div>

          <div class="columns mt-0 mb-0 has-text-grey-light">
            <div class="column p-0 has-text-left">Residual Value</div>
            <div class="column p-0 has-text-right is-narrow">
              {{ solution.pricing.residualValue | formatCurrency(0, solution.pricing.currencyCode) }}
            </div>
          </div>

          <div
            class="columns mt-0 mb-0 has-text-danger has-text-weight-bold"
            v-if="lostValue > 10"
          >
            <div class="column p-0 has-text-left">
              Forfeited Value
              <span class="icon">
                <i class="mdi mdi-alert-circle-outline"></i>
              </span>
            </div>
            <div class="column p-0 has-text-right is-narrow">
              {{ lostValue | formatCurrency(0, solution.pricing.currencyCode) }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: "AtcPriceDisplay",
  props: {
    solution: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data: function() {
    return {};
  },
  methods: {},
  computed: {
    //original ticket fare for ATC Exchange
    originalFare() {
      return this.$store.state.bookTravel?.atc?.price || 0;
    },
    newFare() {
      return Number(this.solution.pricing.total) || 0;
    },
    fareDifference() {
      return (
        Number(this.solution.pricing.totalDifference) -
        Number(this.solution.pricing.exchangePenalty) -
        Number(this.solution.pricing.taxDifference)
      );
    },
    taxDifference() {
      return Number(this.solution.pricing.taxDifference);
    },
    showBreakdown() {
      let show = true;
      if (
        Math.abs(this.calcDifference) -
          Math.abs(Number(this.solution.pricing.totalDifference)) <
        1
      ) {
        show = false;
      }
            //MT: 1 is to account for rounding errors

            if (
        Math.floor(this.taxDifference) == 0 &&
        Math.floor(this.totalDifference) == 0
      ) {
        show = false;
      }


      return show;
    },
    calcDifference() {
      return Number(this.newFare) - Number(this.originalFare);
    },
    residualValue() {
      return Number(this.solution.pricing.residualValue);
    },
    //Amount forfeited due to ATC Exchange
    lostValue() {
      return this.originalFare - this.newFare - this.residualValue; //Values should be in the same currency
    },
    originalCurrency(){
      return this.$store.state.bookTravel?.atc?.currency || "USD";
    }
  },
  mounted() {},
};
</script>
<style scoped></style>
